import { apiConfig, request } from '../io';
import { treeMap } from './treeMap';
// 获取应用系统菜单
export const getMenus = async (systemId) => {
    if (!systemId) {
        return Promise.resolve({
            code: 200,
            data: {
                functionList: [],
                resourceList: [],
                iconPath: '',
                systemId,
                systemName: '',
            },
        });
    }
    const data = await request(`${apiConfig.apiUims}/v1/resource/getMenu/${systemId}`);
    const newData = treeMap(data?.data?.resourceList || [], (node) => {
        return {
            ...node,
        };
    }, {});
    return Promise.resolve({
        code: 200,
        data: {
            ...(data?.data || {}),
            resourceList: newData,
            functionList: data?.data?.functionList || [],
        },
    });
};
// 获取用户权限信息
export const getUserInfo = async (systemId) => {
    if (!systemId) {
        return Promise.resolve({});
    }
    return request(`${apiConfig.apiUims}/v1/resource-function/user/${systemId}/perms`, {
        method: 'get',
    });
};
export function downloadMinioFileApi(bucket, objectName, fileName) {
    return () => new Promise(async (resolve, reject) => {
        try {
            const r = await request(`${apiConfig.apiMinio}/v1/file/download/file`, {
                method: 'get',
                responseType: 'blob',
                params: {
                    bucket,
                    objectName,
                    fileName,
                },
            });
            resolve(new Blob([r]));
        }
        catch (error) {
            reject(error);
        }
    });
}
// 待办事项列表
export async function tasksCustom(data) {
    return request(`${apiConfig.activiti}/v1/tasks/custom/${data.module}/${data.page}/${data.size}?companyId=${data.companyId}&businessName=${data.businessName}&projectId=${data.projectId}`, {
        method: 'get',
    });
}
// 已办、已完结、我参与的列表
export async function taskCustomFinished(data) {
    return request(`${apiConfig.activiti}/v1/historic-task-instances/custom/finished/${data.type}/${data.module}/${data.page}/${data.size}?companyId=${data.companyId}&businessName=${data.businessName}&projectId=${data.projectId}`, {
        method: 'get',
    });
}
// 我发起的列表和抄送我的
export async function processStartuser(data) {
    return request(`${apiConfig.activiti}/v1/historic-process-instances/custom/${data.type}/${data.module}/${data.page}/${data.size}?companyId=${data.companyId}&businessName=${data.businessName}&projectId=${data.projectId}`, {
        method: 'get',
    });
}
// 流程待办统计
export async function taskCount(data) {
    return request(`${apiConfig.activiti}/v1/home/custom/${data.module}/taskCount?companyId=${data.companyId}&businessName=${data.businessName}&projectId=${data.projectId}`, {
        method: 'get',
    });
}
// 项目列表
export async function getProjectTables(data, headers) {
    return request(`${apiConfig.apiSystem}/v1/project/table`, {
        method: 'get',
        params: data,
        headers: headers,
    });
}
// OA审批-数量统计
export async function oaTaskCount(data) {
    return request(`${apiConfig.activiti}/v1/oa/task/count`, {
        method: 'post',
        data,
    });
}
// 审批列表-待办
export async function oaTaskRunning(data) {
    return request(`${apiConfig.activiti}/v1/oa/task/running`, {
        method: 'post',
        data,
    });
}
// 审批列表-已办
export async function oaTaskCompleted(data) {
    return request(`${apiConfig.activiti}/v1/oa/task/completed`, {
        method: 'post',
        data,
    });
}
// 审批列表-我发起的
export async function oaProcessMy(data) {
    return request(`${apiConfig.activiti}/v1/oa/process/my`, {
        method: 'post',
        data,
    });
}
// 审批列表-抄送我的
export async function oaProcessCc(data) {
    return request(`${apiConfig.activiti}/v1/oa/process/cc`, {
        method: 'post',
        data,
    });
}
// 根据系统Id或code获取系统信息
export async function systemInfoQuery(data, headers) {
    return request(`${apiConfig.apiUims}/v1/system/query-base`, {
        method: 'post',
        data,
        headers,
    });
}
// 登出接口
export async function getLogout(data) {
    return request(`/auth/logout?ct=1&userId=${data.id}&fp=${data.fp}&type=app&msg=1`, {
        method: 'get',
    });
}
